export const DATE_FORMAT = {
  SHORT: 'dd/MM/yyyy',
  SHORT_DATE_TIME: 'dd/MM/yyyy HH:mm:ss',
  ISO: 'yyyy-MM-dd',
  DATE_TIME: "yyyy-MM-dd'T'HH:mm:ss.SSS",
}
